import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_Student_PBIS } from "../shared/data.service";
import { MeritPersonUpdateRequest } from "../shared/MeritPersonUpdateRequest";

@Component({
	selector: "app-student-edit-merit",
	templateUrl: "./student-edit-merit.component.html",
	styleUrls: ["./student-edit-merit.component.css"],
})
export class StudentEditMeritComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private PBISService: DataService_Student_PBIS,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		//Get data from parent
		this.user = this.dialogConfig.data.user;
		this.PersonID = this.dialogConfig.data.PersonID;
		this.StudentID = this.dialogConfig.data.StudentID;
		this.StudentName = this.dialogConfig.data.StudentName;
		this.SchoolID = this.dialogConfig.data.SchoolID;

		this.SelectedMeritPerson = this.dialogConfig.data.SelectedMeritPerson;

		//Get data from db
		this.loadMeritsAndDemerits();
	}

	///////////////////////////////////
	// Data
	///////////////////////////////////

	//Data from Parent:
	SelectedMeritPerson: any;
	user: any;
	PersonID: any;
	StudentID: any;
	StudentName: any;
	SchoolID: any;

	//Form
	IsDemerit: any = "0";
	MeritID: any;
	lstMerit: any = [];
	MeritDate: Date = new Date();
	MeritTime: Date = new Date();
	Commment: any = "";
	MeritVal: any = 0;
	MinVal: any = 0;
	MaxVal: any = 0;

	lstAll: any = [];
	AllMerits: any = [];
	AllDemerits: any = [];

	errorMessage: any = "";

	///////////////////////////////////

	///////////////////////////////////
	// Load Data
	///////////////////////////////////

	loadMeritsAndDemerits() {
		var result = this.PBISService.LoadMerits(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstAll = response;

				this.AllMerits = [];
				this.AllDemerits = [];
				for (var i = 0; i < this.lstAll.length; i++) {
					var next = this.lstAll[i];

					if (next.IsDemerit == 1) {
						this.AllDemerits = [...this.AllDemerits, next];
					} else {
						this.AllMerits = [...this.AllMerits, next];
					}
				}

				// this.lstMerit = this.AllMerits;
				// this.MeritID = this.lstMerit[0].MeritID;
				// this.MeritVal = this.lstMerit[0].MeritValue;
				// this.MinVal = this.lstMerit[0].MeritValueMin;
				// this.MaxVal = this.lstMerit[0].MeritValueMax;

				this.UpdateData();
			},
			(error) => {}
		);
	}

	UpdateData() {
		if (this.Commment.length > 254) {
			this.errorMessage = "Comment can't have more than 254 characters. Current comment has " + this.Commment.length + " characters";
			return;
		}

		this.MeritID = this.SelectedMeritPerson.MeritID;

		this.IsDemerit = String(this.SelectedMeritPerson.IsDemerit);

		if (this.SelectedMeritPerson.IsDemerit == 1) {
			this.lstMerit = [];
			this.lstMerit = this.AllDemerits;
		} else {
			this.lstMerit = [];
			this.lstMerit = this.AllMerits;
		}

		for (var i = 0; i < this.lstMerit.length; i++) {
			var next = this.lstMerit[i];

			if (next.MeritID == this.MeritID) {
				this.MinVal = next.MeritValueMin;
				this.MaxVal = next.MeritValueMax;

				break;
			}
		}

		this.MeritVal = this.SelectedMeritPerson.MeritValue;
		this.MeritDate = new Date(this.SelectedMeritPerson.MeritDT);
		this.MeritTime = new Date(this.SelectedMeritPerson.MeritDT);

		this.Commment = this.SelectedMeritPerson.Comment;
	}

	///////////////////////////////////

	///////////////////////////////////
	// Buttons
	///////////////////////////////////
	onUpdate() {
		//@MeritPersonID  INT,
		//@MeritValue  INT,
		//@Comment  VARCHAR(255),
		//@Scanstation  VARCHAR(50) = ''

		if (Number(this.MeritVal) < this.MinVal) {
			this.errorMessage = "Merit value must be < " + this.MinVal;
			return;
		}

		if (Number(this.MeritVal) > this.MaxVal) {
			this.errorMessage = "Merit value must be > " + this.MaxVal;
			return;
		}

		let parms: MeritPersonUpdateRequest = {
			MeritPersonID: this.SelectedMeritPerson.MeritPersonID,
			MeritValue: this.MeritVal,
			Comment: this.Commment,
			ScanStation: "",
		};

		var result = this.PBISService.MeritPersonUpdate(parms);

		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Merit was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Merit",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////

	///////////////////////////////////
	// Events
	///////////////////////////////////
	onTypeChange(val) {
		this.IsDemerit = val;

		if (this.IsDemerit == "0") {
			this.lstMerit = [];
			this.lstMerit = this.AllMerits;
		} else {
			this.lstMerit = [];
			this.lstMerit = this.AllDemerits;
		}

		this.MeritID = this.lstMerit[0].MeritID;
		this.MeritVal = this.lstMerit[0].MeritValue;
		this.MinVal = this.lstMerit[0].MeritValueMin;
		this.MaxVal = this.lstMerit[0].MeritValueMax;
	}

	onMeritChange(val) {
		this.MeritID = val;

		for (var i = 0; i < this.lstMerit.length; i++) {
			var next = this.lstMerit[i];

			if (next.MeritID == this.MeritID) {
				this.MeritVal = next.MeritValue;
				this.MinVal = next.MeritValueMin;
				this.MaxVal = next.MeritValueMax;
				break;
			}
		}
	}

	///////////////////////////////////
}
